import {ValidationErrorLabel} from 'graphql-client/__generated/graphqlGlobalTypes';

export function getTenantLevelInventorySettingsURL(): string {
  return '/inventory-settings';
}

// Keep in sync with INVENTORY_ERROR_LABEL_CONSTANT_TO_TEXT in benchling/search/interface/filters/inventory_validation_error_label_filter.py
export enum InventoryValidationErrorLabel {
  OVER_CAPACITY = ValidationErrorLabel.OVER_CAPACITY,
  ITEM_TYPES_DISALLOWED = ValidationErrorLabel.ITEM_TYPES_DISALLOWED,
  NON_LOCATION_ITEMS_DISALLOWED = ValidationErrorLabel.NON_LOCATION_ITEMS_DISALLOWED,
}
/*
 * Controls how many entities can be selected in a cell and whether duplicates are allowed.
 *
 * SINGLE: Only one entity allowed per cell
 * MULTIPLE_DISTINCT: Multiple entities allowed, but each must be unique (no duplicates within the cell)
 * MULTIPLE_WITH_DUPLICATES: Multiple entities allowed, including duplicates (same entity can appear multiple times)
 */
export enum EntitySelectionMode {
  SINGLE = 'SINGLE',
  MULTIPLE_DISTINCT = 'MULTIPLE_DISTINCT',
  MULTIPLE_WITH_DUPLICATES = 'MULTIPLE_WITH_DUPLICATES',
}
